import { render } from "./APButton.vue?vue&type=template&id=7f2804a8&scoped=true"
import script from "./APButton.vue?vue&type=script&lang=js"
export * from "./APButton.vue?vue&type=script&lang=js"

import "./APButton.vue?vue&type=style&index=0&id=7f2804a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f2804a8"]])

export default __exports__